import React, { useState, useEffect } from "react";
import { format, subMonths } from "date-fns";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { getBrandOptions, toLakhs } from "../../utils/constants";
import * as XLSX from "xlsx";
import ScrollContainer from "react-indiana-drag-scroll";

function PlanningSheetRollingMonth() {
  let monthArray = [];
  let currDate = new Date().setDate(1);
  for (let i = 0; i < 12; i++) {
    let start = format(currDate, "MMMyy");
    currDate = subMonths(currDate, 1);
    monthArray.push(`${start}`);
  }
  monthArray.reverse();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const newspaperCategories = [
    "education & careers",
    "retail",
    "healthcare & hospitals",
    "real estate / construction",
    "fmcg",
  ];
  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/monthly/planning-sheet-rolling-month",
        method: "POST",
        responseType: "json",
        data: {
          type:selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      const headers = [["", ...monthArray]]; // First row for months

      const rows = [
        ["Total Deployed Accounts", ...monthArray.map((month) => data['deployedAccounts']?.[month.toLowerCase()] || 0)],
  
        ["W2N"], // Section Header
        ["Accounts Advertised", ...monthArray.map((month) => getRecord("paper", "w2n", month)?.brand_count || 0)],
        ["No. of Insertions", ...monthArray.map((month) => getRecord("paper", "w2n", month)?.total_insertions || 0)],
        ["Revenues", ...monthArray.map((month) => getRecord("paper", "w2n", month)?.total_revenue || 0)],
  
        ["Eenadu"], // Section Header
        ["Accounts Advertised", ...monthArray.map((month) => getRecord("paper", "eenadu", month)?.brand_count || 0)],
        ["No. of Insertions", ...monthArray.map((month) => getRecord("paper", "eenadu", month)?.total_insertions || 0)],
        ["Revenues", ...monthArray.map((month) => getRecord("paper", "eenadu", month)?.total_revenue || 0)],
      ];
  
      // Add each newspaper category dynamically
      newspaperCategories.forEach((category) => {
        rows.push([category]); // Category header
        rows.push([
          "Accounts Advertised",
          ...monthArray.map((month) => getRecord("category", "eenadu", month, category)?.brand_count || 0),
        ]);
        rows.push([
          "No. of Insertions",
          ...monthArray.map((month) => getRecord("category", "eenadu", month, category)?.total_insertions || 0),
        ]);
        rows.push([
          "Revenues",
          ...monthArray.map((month) => getRecord("category", "eenadu", month, category)?.total_revenue || 0),
        ]);
      });
  
      // Create Excel workbook
      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Planning Sheet Rolling Month");
      XLSX.writeFile(workbook, `PlanningSheetRollingMonth.xlsx`);
  
    } catch (error) {
    } finally {
      setDownloadLoader(false);
    }
  };
  const preprocessedPaperwiseData = data?.paperwiseData?.reduce((acc, item) => {
    const key = `${item.year_month}_${item.newspaper_name}`;
    acc[key] = item;
    return acc;
  }, {});
  
  const preprocessedCategorywiseData = data?.newsPaperCatgeoryWise?.reduce((acc, item) => {
    const key = `${item.year_month}_${item.newspaper_name}_${item.category_name}`;
    acc[key] = item;
    return acc;
  }, {});

  
  const getRecord = (type, from, month, category = "") => {
    const match = from === "w2n" ? "Way2news" : "Eenadu";
    let key, data;
  
    if (type === "paper") {
      key = `${month}_${match}`;
      data = preprocessedPaperwiseData;
    } else if (type === "category") {
      key = `${month}_${match}_${category}`;
      data = preprocessedCategorywiseData;
    }
    if(!data) return { total_revenue: 0, total_insertions: 0, brand_count: 0 };
    
    return data.hasOwnProperty(key) ? data[key] : { total_revenue: 0, total_insertions: 0, brand_count: 0 };
    
  };
  
  
  const renderStatsRow = (label, field, type, from, category = "") => (
    <tr>
      <td>{label}</td>
      {monthArray.map((month) => {
        const accounts = getRecord(type, from, month.toLowerCase(), category);
        if(field === "total_revenue") {
          return <td>{toLakhs(accounts[field])}</td>;
        }
        return <td>{accounts[field]}</td>;
      })}
    </tr>
  );
  
  useEffect(() => {
    fetchData();
  }, [selectedType]);

  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>12 months Rolling Average</h5>
        <aside className="flex gap-3 items-center">
        <SlSelect size="small" value={selectedType} label="Team"  onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
      <table className="table table-bordered mt-2">
  <thead>
    <tr>
      <th></th>
      {monthArray.map((item, index) => (
        <th key={`month-${index}`}>{item}</th>
      ))}
    </tr>
  </thead>

  {!loader && Object.keys(data)?.length > 0 ? (
    <tbody>
      <tr>
        <th>Total Deployed Accounts (Eenadu + W2N)</th>
        {monthArray.map((item, index) => <td key={`deployed-${index}`}>
          {data['deployedAccounts']?.[item.toLowerCase()] || 0}
        </td>)}
      </tr>

      <tr>
        <th colSpan={14}>W2N</th>
      </tr>
      {["brand_count", "total_insertions", "total_revenue"].map((field, index) => 
        renderStatsRow(["Accounts Advertised", "No. of Insertions", "Revenues"][index], field, "paper", "w2n")
      )}

      <tr>
        <th colSpan={14}>Eenadu</th>
      </tr>
      {["brand_count", "total_insertions", "total_revenue"].map((field, index) => 
        renderStatsRow(["Accounts Advertised", "No. of Insertions", "Revenues"][index], field, "paper", "eenadu")
      )}

      {newspaperCategories.map((category, catIndex) => (
        <React.Fragment key={`category-${catIndex}`}>
          <tr>
            <th colSpan={14}>{category}</th>
          </tr>
          {["brand_count", "total_insertions", "total_revenue"].map((field, index) => 
            renderStatsRow(["Accounts Advertised", "No. of Insertions", "Revenues"][index], field, "category", "eenadu", category)
          )}
        </React.Fragment>
      ))}
    </tbody>
  ) : loader ? (
    <TableSkelton colspan={13} />
  ) : (
    <NoDataFound colspan={13} />
  )}
</table>
</ScrollContainer>
    </>
  );
}

export default PlanningSheetRollingMonth;
